import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SystemAccountAuthModel } from '../../../../core/models/system-account';
import { IAuthService } from '../../../../core/services/api/contracts/auth-service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss', "../index/index.component.css"]
})
export class AdminHomeComponent implements OnInit {
  public currentUser: SystemAccountAuthModel;
  public organizations: string[];

  constructor(private router: Router,
    @Inject("IAuthService") private authService: IAuthService) { }

  async ngOnInit() {
    this.currentUser = await this.authService.getCurrentProfile();
    this.loadOrganizations();
  }

  async logout() {
    await this.authService.logout();
    await this.router.navigate(["/"]);
  }

  loadUserInfo() {
    if (this.currentUser && this.currentUser.email) {
      var user = this.currentUser.organizations[0].name.toString();
     return `${user}`;
    } else {
      return "";
    }
  }

  loadOrganizations() {
    if (this.currentUser && this.currentUser.organizations) {
      this.organizations = this.currentUser.organizations.map(
        org => org.name
        );
        
    }
  }
}
